
  <form (ngSubmit)="onSubmit()" [formGroup]="messageForm" nz-form [nzLayout]="'vertical'" (reset)="resetForm()">
    <nz-spin [nzSpinning]="isLoading">
      
      <div style="margin-bottom: 6px; ">    
        <nz-row [nzGutter]="8">
          <nz-col [nzXs]="24" [nzSm]="12" [nzMd]="12" [nzLg]="12">
            <nz-form-item>
              <nz-form-label nzRequired>Title</nz-form-label>
              <nz-form-control nzErrorTip="Please enter a title">
                <input nz-input 
                       name="title" 
                       formControlName="title"
                       placeholder="Enter communication title"
                       required
                        />
              </nz-form-control>
            </nz-form-item>
          </nz-col>
          
          <nz-col [nzXs]="24" [nzSm]="12" [nzMd]="12" [nzLg]="12">
            <nz-form-item>
              <nz-form-label>Popup Display</nz-form-label>
              
              <nz-form-control>
                <label nz-checkbox 
                       formControlName="isPopup"
                       name="forcePopup"
                       style="display: flex; align-items: start;">
                  <p>Force Popup Display</p>
                </label>
                
              </nz-form-control>
            </nz-form-item>
          </nz-col>
        </nz-row>
      </div>

      <div>     
        <nz-form-item>
          <nz-form-label nzRequired>Message Content</nz-form-label>
          <nz-form-control nzErrorTip="Please enter message content">
            <quill-editor 
              #quillEditor
              formControlName="content"
              [modules]="quillConfig"
              style="height: 200px; width: 100%;"
              (onEditorCreated)="onEditorCreated($event)"
              [sanitize]="false">
            </quill-editor>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div>
        <nz-form-item nz-tooltip="Upload a PDF attachment to include with the message.">
          <nz-form-control>
            <input nz-input type="file" 
                    formControlName="pdf"
                   (change)="handlePdfUpload($event)" 
                   accept="application/pdf" />
            </nz-form-control>
        </nz-form-item>
      </div>

      <div>
        <app-polling #pollingComponent (pollCreated)="receivedNewPoll($event)"></app-polling>
      </div>
      <div style="margin-bottom: 6px;">
        <app-send-comm #sendCommComponent [availableRecipients]="availableRecipients"
         (sendMessageConfig)="receivedSendMessageConfig($event)" 
         ></app-send-comm>
      </div>

      <div nz-row [nzJustify]="'space-around'" style="text-align: center; margin-top: 12px;">   
        <button nz-button 
                nzType="default" 
                nzSize="large"
                [nzLoading]="isLoading"
                (click)="resetForm()"
                >
          Reset
        </button>     
        <button nz-button 
                nzType="primary" 
                nzSize="large"
                [nzLoading]="isLoading"
                type="submit"
                >
          <span nz-icon nzType="send" nzTheme="outline"></span>
          Send 
        </button>
        
      </div>
      
    </nz-spin>
  </form>
